export default {
 items: [

  {
   name: 'Cesta',
   url: '/cart',
   icon: 'icon-basket-loaded'
  },

  {
   name: 'Tickets',
   url: '/tickets',
   icon: 'icon-list'
  },

  {
   name: 'Facturas',
   url: '/invoices',
   icon: 'icon-briefcase'
  },

  {
   name: 'Libro de cuentas',
   url: '/account',
   icon: 'fa fa-area-chart'
  },

  {
   name: 'Productos',
   url: '/products',
   icon: 'icon-note'
  },

  {
   name: 'Clientes',
   url: '/clients',
   icon: 'icon-user'
  }

 ]
};



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/sidebar/_nav.js